<template>
    <main>
        <div class="banner">
            <div class="w-50 image">
                <img src="/images/healthcare2.jpg" alt="" data-aos="zoom-out-up">
            </div>
            <div class="w-50 content">
                <p class="subtitle" data-aos="fade-up" data-aos-delay="100">
                    <strong>
                        <span v-if="selectedLang() == 'en'">WHAT WE DO</span>
                        <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">ماذا نفعل</bdo></span>
                        <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">چی دەکەین </bdo></span>
                    </strong>
                </p>
                <p class="title" data-aos="fade-up" data-aos-delay="200">
                    <span v-if="selectedLang() == 'en'">Kurdos Wellness</span>
                    <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">صحة</bdo></span>
                    <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">تەندروستی</bdo></span>
                </p>
                <p class="text text1" data-aos="fade-up" data-aos-delay="300">
                    <span v-if="selectedLang() == 'en'">Kurdos Wellness offers a wide range Branded Generic
                        pharmaceutical products which include
                        parenterals and orals for therapeutic application in Oncology, Cardiovascular, Diabetes,
                        Analgesics & Anti-Inflammator y apar t from Anest hesia and Narcotics products.</span>
                    <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">تقدم كوردوس ويلنس مجموعة واسعة من المنتجات
                            الصيدلانية العامة ذات العلامات التجارية، والتي تشمل الحقن والفم للاستخدام العلاجي في علاج
                            الأورام وأمراض القلب والأوعية الدموية والسكري، بالإضافة إلى مسكنات الألم ومضادات الالتهاب،
                            بالإضافة إلى منتجات التخدير والمسكنات.</bdo></span>
                    <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">کوردۆس وێڵنێس کۆمەڵێک بەرهەمی دەرمانی براند
                            جنێریک پێشکەش دەکات کە بریتین لە...
                            پەرەنتەراڵ و زارەکی بۆ بەکارهێنانی چارەسەری لە ئۆنکۆلۆژی، دڵ و خوێنبەرەکان، شەکرە،
                            دەرمانی ئازارشکێن و دژە هەوکردن بە جیا لە بەرهەمەکانی بێهۆشکەر و ماددە
                            هۆشبەرەکان.</bdo></span>

                </p>
                <p class="text text2" data-aos="fade-up" data-aos-delay="400">

                    <span v-if="selectedLang() == 'en'">We offer <strong> Specialty Pharmaceuticals </strong> under the
                        segments: Human
                        Plasma Products, Oncology, Wound Care, Cardiovascular, Orthopedic
                        and Neurology.</span>
                    <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">نقدم منتجات صيدلانية متخصصة في قطاعات: منتجات
                            البلازما البشرية، الأورام، العناية بالجروح، أمراض القلب والأوعية الدموية، العظام
                            والأعصاب.</bdo></span>
                    <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">ئێمە دەرمانی تایبەتمەند پێشکەش دەکەین لە ژێر
                            سێگمێنتەکانی: مرۆیی
                            بەرهەمەکانی پلازما، ئۆنکۆلۆژی، چاودێری برین، دڵ و خوێنبەرەکان، ئێسک و دەمار.</bdo></span>
                </p>
                <p class="text text3" data-aos="fade-up" data-aos-delay="500">
                    <span v-if="selectedLang() == 'en'">We also have a wide range <strong> Nutraceuticals </strong> in
                        our product portfolio.</span>
                    <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">لدينا أيضًا مجموعة واسعة من المواد المغذية في
                            محفظة منتجاتنا.</bdo></span>
                    <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">هەروەها ئێمە کۆمەڵێک خۆراکی بەرفراوانمان هەیە لە
                            پۆرتفۆلیۆی بەرهەمەکانماندا.</bdo></span>

                </p>
            </div>
        </div>
        <div class="products">
            <div class="product" v-for="i in products" :key="i" data-aos="fade-up">
                <div class="product-image">
                    <img :src="i.image" alt="">
                </div>
                <div class="content2">
                    <p>{{ i.title }}</p>
                </div>
            </div>
        </div>
    </main>
</template>

<script setup>
import { ref } from 'vue'
import { selectedLang } from '../../utils/selected_lang';

const products = ref([
    {
        image: '/healthcare_images/wellness/KURDOS-HEALTHCARE-TAB (1).pdf-image-004.png',
        title: 'Azit hromycin Tablets',
    },
    {
        image: '/healthcare_images/wellness/KURDOS-HEALTHCARE-TAB (1).pdf-image-006.png',
        title: 'Aceclofenac & Paracetamol Tablets',
    },
    {
        image: '/healthcare_images/wellness/KURDOS-HEALTHCARE-TAB (1).pdf-image-010.png',
        title: 'Ibuprofen Oral Suspension',
    },
    {
        image: '/healthcare_images/wellness/KURDOS-HEALTHCARE-TAB (1).pdf-image-012.png',
        title: 'Ciprofloxacin Tablets',
    },
    {
        image: '/healthcare_images/wellness/KURDOS-HEALTHCARE-TAB (1).pdf-image-016.png',
        title: 'Ciprofloxacin Tablets',
    },
    {
        image: '/healthcare_images/wellness/KURDOS-HEALTHCARE-TAB (1).pdf-image-018.png',
        title: 'Amikacin Sulphate Injection',
    },
    {
        image: '/healthcare_images/wellness/KURDOS-HEALTHCARE-TAB (1).pdf-image-022.png',
        title: 'Human Albumin',
    },
    {
        image: '/healthcare_images/wellness/KURDOS-HEALTHCARE-TAB (1).pdf-image-026.png',
        title: 'Biotin Suppliment',
    },
    {
        image: '/healthcare_images/wellness/KURDOS-HEALTHCARE-TAB (1).pdf-image-028.png',
        title: 'Folic Acid',
    },

])

</script>

<style scoped>
* {
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif !important;
}

main {
    /* color: #073762 !important;  */
    background: #F6F8FB;
    padding: 50px 100px;

}


.dark main {
    background: #131313;
    color: white !important;
}
.dark .banner{
    background: #323232;
}
.dark .content p, .dark .title{
    color: white;
}
.dark .product{
    background: #323232;
}
.dark .content2 p{
    color: #fff !important;
}


.banner {
    display: flex;
    background: white;
    padding: 20px;
    border-radius: 15px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    margin-bottom: 56px;
}

.w-50 {
    width: 50%;
}

.image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 15px;
}

.content {
    padding: 50px;
}
.title{
    line-height: 2.1rem !important;
}

.title,
.subtitle {
    padding: auto; 
    text-transform: uppercase;
}

.subtitle {
    color: #E43D34 !important;
    font-size: 18px !important;
}

.title {
    color: #073762;
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 20px;
}

.content p {
    color: #073762;

}



.products {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
}

.product {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    transition: transform 0.2s ease;
    padding: 10px;
}

.product:hover {
    transform: translateY(-5px);
}

.product-image {
    width: 100%;
    height: 220px;
    overflow: hidden;
    border-radius: 10px;
}

.product-image img {
    height: 100%;
    width: 100%;
    object-fit: cover;
}

.content2 {
    padding: 1rem;
    text-align: center;
}

.content2 p {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 500;
    color: #073762 !important;
}


@media (max-width: 768px) {
    main {
        padding: 20px;
    }

    .banner {
        flex-direction: column;
    }

    .w-50 {
        width: 100%;
    }

    .content {
        padding: 20px;
    }
}
</style>